import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from './components/layout/Layout';
import Home from './components/main/Home/Home';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import CableTv from './components/Pages/CableTv/CableTv';
import GetAQoute from './components/Pages/GetAQoute/GetAQoute';
import Internet from './components/Pages/Internet/Internet';
import PhonePg from './components/Pages/PhonePg/PhonePg';
import SpecialOffer from './components/Pages/SpecialOffer/SpecialOffer';
import OptimumInternet from './components/Pages/OptimumInternet/OptimumInternet';
import RefreshOnRouteChange from './RefreshOnRouteChange';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Privacy from './components/main/Common/Privacy/Privacy';
import SearchChamerlean from './components/main/Common/Chamerlean/SearchChamerlean';
import CompanyPage from './components/main/Common/CompanyPages/CompanyPage';
import LeadCaptureForms from './components/main/Common/Deals/LeadCaptureForms';
import Header from './components/main/Common/Deals/Header';
import Business from './components/main/Common/Business/Business';
import WirelessDeals from './components/main/Common/WirelessDeals/WirelessDeals';
import SecondLeadCaptureForms from './components/main/Common/SecondDeal/LeadCaptureFormsCopy';
import PrepaidPlanForm from './components/main/Common/PrepaidPlan/PrepaidPlanForm';
import PrepaidPlanDeals from './components/main/Common/PrepaidPlanDeals/PrepaidPlanDeals';
// import FiberDeals from './components/main/Common/FiberDeals/FiberDeals.jsx'
import FiberDeals from './components/main/Common/FiberDeals'
import Offers from './components/main/Common/Offers/Offers';
import CableDeals from './components/main/Common/CableDeals/CableDeals';
import FiberOffer from './components/main/Common/FiberOffer/FiberOffer';
import WindstreamDeals from './components/main/Common/WindstreamDeals/WindstreamDeals';

import ThankYouPage from './components/main/Common/ThankYouPage/ThankYouPage';

function App() {
  return (
    <div className="App">
      <Router>
        <ToastContainer />
        <RefreshOnRouteChange />
        <Routes>
          {/* Guest routes here */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/roanmoving" element={<Home />} />
            <Route path="/cabletv" element={<CableTv />} />
            <Route path="/search" element={<SearchChamerlean />} />
            <Route path="/internet" element={<Internet />} />
            <Route path="/getaqoute" element={<GetAQoute />} />
            <Route path="/phone" element={<PhonePg />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            {/* <Route path="/deals" element={<LeadCaptureForms />} /> */}
            {/* <Route path="/all-deals/:zipcode" element={<Deals />} /> */}
            <Route path="/business" element={<Business />} />
            <Route path="/:slug" element={<CompanyPage />} />
            {/* Add your public routes here eg. <Route path="example" element={<Component />} /> */}
          </Route>
          <Route path="/deals" element={<><Header /><LeadCaptureForms /></>} />
          <Route path="/prepaid-plans" element={<><Header /><PrepaidPlanForm /></>} />
          <Route path="/wirelessdeals-ns" element={<><Header /><SecondLeadCaptureForms /></>} />
          <Route path="/wireless-deals" element={<><Header /><WirelessDeals /></>} />
          <Route path="/prepaidPlans" element={<><Header /><PrepaidPlanDeals /></>} />
          <Route path="/fiberdeals" element={<><Header /><FiberDeals /></>} />
          <Route path="/fiber-deals" element={<><Header /><FiberDeals /></>} />
          <Route path="/offers" element={<><Header /><Offers /></>} />
          <Route path="/cabledeals" element={<><Header /><CableDeals /></>} />
          <Route path="/fiberoffers" element={<><Header /><FiberOffer /></>} />
          <Route path="/fiberplans" element={<><Header /><WindstreamDeals /></>} />
          <Route path="/thank-you" element={<><Header /><ThankYouPage /></>} />
          <Route path="/optimum" element={<OptimumInternet />} />
          <Route path="/optimum-offer" element={<SpecialOffer />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
